import { render, staticRenderFns } from "./LoginWithProvidersBtn.vue?vue&type=template&id=17953192&scoped=true&"
import script from "./LoginWithProvidersBtn.vue?vue&type=script&lang=js&"
export * from "./LoginWithProvidersBtn.vue?vue&type=script&lang=js&"
import style0 from "./LoginWithProvidersBtn.vue?vue&type=style&index=0&id=17953192&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17953192",
  null
  
)

export default component.exports